<div class="p-my-1 p-inputgroup" *ngIf="showPrize && !isLoading">
  <div>
    <span [style]="{ 'width': '100%' }" ngClass="p-float-label">
      <div>
        <p-fieldset class="p-formgroup-inline">
          <!-- Header -->
          <ng-template pTemplate="header">
            <div class="p-formgroup-inline">
              <span class="p-my-auto p-mr-2">{{ fieldsetName }}</span>
              <!-- Add Reward Button -->
              <button pButton icon="pi pi-plus p-panel-header-icon" class="p-button-rounded p-button-text p-button"
                (click)="addReward()" type="button"></button>
            </div>
          </ng-template>
          <p-orderList [value]="prize" (onReorder)="reorder(prize);"
            [listStyle]="{ 'width': '100%', 'max-height': '40vh', 'overflow-y': 'auto' }" [header]="''"
            [dragdrop]="true">
            <ng-template let-reward pTemplate="item" let-i="index">
              
              <ng-container>
                <div style="display: flex; justify-content: space-between; align-items: flex-start">
                  <ng-container *ngIf="isChallenge">
                    <h3 class="p-my-2">Prize {{i == 0 ? '4.0' : '5.0'}}</h3>
                  </ng-container>
                  <ng-container *ngIf="!isChallenge">
                    <small class="p-my-2">Resource {{i + 1}}</small>
                  </ng-container>
                  <button pButton type="button" icon="pi pi-times"
                      class="p-button-rounded p-button-text p-button-danger delete-button p-mb-1"
                      (click)="deleteReward(i)"></button>
                </div>
              </ng-container>
                <div class="flex-container">
                  <!-- Dropdown for Resource Selection -->
                  <div class="flex-item resource-container" *ngIf="defaultResourceType === null">
                    <div class="field-wrapper">
                      <p-dropdown [(ngModel)]="reward.t" appendTo="body" [ngModelOptions]="{standalone: true}"
                        [options]="options['t']" optionLabel="name" placeholder="Resource" [showClear]="false"
                        [autoDisplayFirst]="false" [filter]="true" [filterBy]="'name'" [required]="true"
                        [optionValue]="useOptionValue ? '_id' : null" (onChange)="updateDependentField($event,i)">
                        <ng-template let-option pTemplate="item">
                          <span>{{option.name}} ({{option.id}})</span>
                        </ng-template>
                      </p-dropdown>
                      <button *ngIf="hasFieldValue(reward, 'resource')" 
                        type="button"
                        class="clear-button-inside"
                        (click)="clearAutoCompleteField(i, 'resource')"
                        title="Clear selection">
                        <i class="pi pi-times"></i>
                      </button>
                    </div>
                  </div>
                  <!-- AutoComplete or Dropdown for ID -->
                  <div class="flex-item id-container">
                    <!-- Conditional rendering for AutoComplete or Dropdown -->
                    <div class="field-wrapper" *ngIf="!isCostField">
                      <p-autoComplete appendTo="body" [(ngModel)]="reward.id"
                        [ngModelOptions]="{standalone: true}" [suggestions]="suggestions['id']" [showEmptyMessage]="true"
                        (completeMethod)="reward.t && reward.t.name ? getSuggestionsForRef($event.query, 'id', resourceMap[reward.t.name]) : null"
                        [field]="'displayName'" [minLength]="1" [delay]="300" placeholder="Search by Name or ID" [required]="true"
                        [forceSelection]="true" [disabled]="!reward.t || !reward.t.name"
                        (onSelect)="onItemSelect($event, reward); onPrizeChange.emit(this.prize)"
                        (keydown)="onKeyDown($event)">
                        <ng-template let-item pTemplate="item">
                          <span>{{item.name}} ({{item.id}})</span>
                        </ng-template>
                      </p-autoComplete>
                      <button *ngIf="hasFieldValue(reward, 'id')" 
                        type="button"
                        class="clear-button-inside"
                        (click)="clearAutoCompleteField(i, 'id')"
                        title="Clear selection">
                        <i class="pi pi-times"></i>
                      </button>
                    </div>
                    <div class="field-wrapper" *ngIf="isCostField">
                      <p-dropdown appendTo="body" [(ngModel)]="reward.id" [options]="options['id']"
                        placeholder="Select a Currency" optionLabel="name" optionValue="_id" [showClear]="false"
                        [autoDisplayFirst]="false" [filter]="true" [filterBy]="'name'" [style]="{ 'width': '100%' }"
                        [required]="true" (onChange)="onPrizeChange.emit(this.prize)">
                        <ng-template let-currency pTemplate="item">
                          <p>{{currency.name}} ({{currency.id}})</p>
                        </ng-template>
                      </p-dropdown>
                      <button *ngIf="hasFieldValue(reward, 'id')" 
                        type="button"
                        class="clear-button-inside"
                        (click)="clearAutoCompleteField(i, 'id')"
                        title="Clear selection">
                        <i class="pi pi-times"></i>
                      </button>
                    </div>
                  </div>
                <!-- Input for Count and Delete Button -->
                <div class="count-container">
                  <span class="p-float-label count-input">
                    <p-inputNumber [(ngModel)]="reward.c" [ngModelOptions]="{standalone: true}"
                      (onBlur)="onPrizeChange.emit(prize)" [style]="{'max-width': '80px'}"
                      id="count-{{i}}">
                    </p-inputNumber>
                    <label for="count-{{i}}">Count</label>
                  </span>
                </div>
              </div>
            </ng-template>
          </p-orderList>
        </p-fieldset>
      </div>
    </span>
  </div>
</div>
